<template>
  <v-skeleton-loader
    v-if="isLoading"
    type="text"
    width="110px"
  />
  <DpplButtonToggle
    v-else
    v-model="openDrawer"
    class="filters-toggle"
    :class="{ 'use-wide-screen-breakpoint': useWideScreenBreakpoint }"
    checked-label="Hide filters"
    unchecked-label="Show filters"
    :checked-color="bgDark"
    :unchecked-color="bgDefault"
    :use-disabled-label="useDisabledLabel"
    disabled-label="Hide filters"
    :is-disabled="isLoading || isDisabled"
  >
    <template #prepend>
      <v-icon icon="$filter-list" :size="24" />
    </template>

    <template #append>
      <AppliedFiltersDot
        v-if="areFiltersApplied"
        class="ml-2"
      />
    </template>
  </DpplButtonToggle>
</template>

<script setup>
import { computed } from 'vue';
import DpplButtonToggle from '@/components/datapeople/DpplButtonToggle.vue';
import AppliedFiltersDot from '@/components/filter/AppliedFiltersDot.vue';
import { useAppBase } from '@/stores/app/base';
import { useColors } from '@/composables/colors';
import { storeToRefs } from 'pinia';

const props = defineProps({
  isLoading: {
    type: Boolean,
    default: false,
  },
  isDisabled: {
    type: Boolean,
    default: false,
  },
  areFiltersApplied: {
    type: Boolean,
    default: false,
  },
  modelValue: {
    type: Boolean,
    default: false,
  },
  useWideScreenBreakpoint: {
    type: Boolean,
    default: true,
  },
});

const emit = defineEmits(['update:model-value']);

const { bgDark, bgDefault } = useColors();

const appBaseStore = useAppBase();
const { windowWidth } = storeToRefs(appBaseStore);

const openDrawer = computed({
  get: () => props.modelValue,
  set: (value) => emit('update:model-value', value),
});

const useDisabledLabel = computed(() => windowWidth.value > 1799 && props.useWideScreenBreakpoint);
</script>

<style lang="less" scoped>
.filters-toggle.use-wide-screen-breakpoint {
  @media screen and (min-width: 1800px) {
    pointer-events: none;
    filter: opacity(0.5);
  }
}

:deep(.v-skeleton-loader__text) {
  margin: 12px;
}
</style>
